export default {
  boxes: [],
  box: {}
}